import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import SiteLayout from "./layouts/SiteLayout";

import Calculator from "./pages/Calculator";                  // home (tax)
import CalculatorsIndex from "./pages/CalculatorsIndex";
import RetirementCalculator from "./pages/RetirementCalculator";
import InflationCalculator from "./pages/InflationCalculator";

import ResourcesRouter from "./pages/ResourcesRouter";        // BLOG router (index + slug)
import ExternalResources from "./pages/ExternalResources";    // external resources page

// Tools
import ToolsIndex from "./pages/ToolsIndex";
import QuarterlyTaxDeadlines from "./pages/QuarterlyTaxDeadlines";
import MileageLog from "./pages/MileageLog";
import StateTaxComparison from "./pages/StateTaxComparison";
import BreakEvenCalculator from "./pages/BreakEvenCalculator";
import ExpenseTracker from "./pages/ExpenseTrackerNew";
import ExpenseTrackerLogin from "./pages/ExpenseTrackerLogin";
import ExpenseTrackerPromo from "./pages/ExpenseTrackerPromo";
import ExpenseTrackerSignup from "./pages/ExpenseTrackerSignup";
import InvoiceManager from "./pages/InvoiceManager";

import FAQ from "./pages/Faq";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Trends from "./pages/Trends";
import ThankYou from "./pages/ThankYou";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<SiteLayout />}>
          {/* Home = Tax Calculator */}
          <Route index element={<Calculator />} />

        {/* Calculators */}
        <Route path="calculators" element={<CalculatorsIndex />} />
        <Route path="calculators/inflation" element={<InflationCalculator />} />
        <Route path="retirement" element={<RetirementCalculator />} />

        {/* Tools */}
        <Route path="tools" element={<ToolsIndex />} />
        <Route path="tools/quarterly-tax-deadlines" element={<QuarterlyTaxDeadlines />} />
        <Route path="tools/mileage-log" element={<MileageLog />} />
        <Route path="tools/state-tax-comparison" element={<StateTaxComparison />} />
        <Route path="tools/break-even-calculator" element={<BreakEvenCalculator />} />
        <Route path="tools/expense-tracker" element={<ExpenseTrackerPromo />} />
        <Route path="tools/expense-tracker/signup" element={<ExpenseTrackerSignup />} />
        <Route path="tools/expense-tracker/app" element={<ExpenseTracker />} />
        <Route path="tools/expense-tracker/login" element={<ExpenseTrackerLogin />} />
        <Route path="tools/invoices" element={<InvoiceManager />} />

        {/* Blog (resources) */}
        {/* Put the specific route FIRST so it doesn't get gobbled by /blog/* */}
        <Route path="blog/external" element={<ExternalResources />} />
        <Route path="blog/*" element={<ResourcesRouter />} />

        {/* Other sections */}
        <Route path="faq" element={<FAQ />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="trends" element={<Trends />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />

        {/* Netlify form redirect target */}
        <Route path="thank-you" element={<ThankYou />} />
      </Route>
    </Routes>
    </>
  );
}
